import React, { FC, PropsWithChildren } from 'react'

export const HeaderMenu: FC<PropsWithChildren> = ({ children }) => {
  return <nav className="mr-auto flex items-center gap-2 sm:gap-4 text-white/50">{children}</nav>
}
